import { X } from "lucide-react";

import { Button } from "~/components/ui/button";
import { Dialog, DialogContent } from "~/components/ui/dialog";

interface VideoModalProps {
  videoId: string;
  onClose: () => void;
}

export function VideoModal({ videoId, onClose }: VideoModalProps) {
  return (
    <Dialog open={true} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-4xl overflow-hidden p-0">
        <div className="relative h-0 pb-[56.25%]">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 h-full w-full"
          ></iframe>
        </div>
        <Button
          size="icon"
          variant="ghost"
          className="absolute top-2 right-2 rounded-full"
          onClick={onClose}
        >
          <X className="h-4 w-4" />
        </Button>
      </DialogContent>
    </Dialog>
  );
}
